/**
 * CLEAN UI THEME SETTINGS
 */
import $ from 'jquery';

var cleanUI = {
    hasTouch: (function() { return ('ontouchstart' in document.documentElement) })()
};
/**
 * CLEAN UI TEMPLATE SCRIPTS
 */
$(function(){
    
    if (!$('body').hasClass('menu-top')) {
        if (!cleanUI.hasTouch) {
            if (!cleanUI.hasTouch) {
                $('nav.left-menu .scroll-pane').each(function() {
                    $(this).jScrollPane({
                        autoReinitialise: true,
                        autoReinitialiseDelay: 100
                    });
                    var api = $(this).data('jsp'),
                        throttleTimeout;
                    $(window).bind('resize', function() {
                        if (!throttleTimeout) {
                            throttleTimeout = setTimeout(function() {
                                api.reinitialise();
                                throttleTimeout = null;
                            }, 50);
                        }
                    });
                });
            }
        }
    }


    /////////////////////////////////////////////////////////////////////////////
    // Toggle menu on viewport < 768px

    $('.left-menu-toggle').on('click', function(){
        $(this).toggleClass('active');
        $('nav.left-menu').toggleClass('left-menu-showed');
        $('nav.top-menu').toggleClass('ob-left-nav-adjust');
        $('.main-backdrop').toggleClass('main-backdrop-showed');
    });


    /////////////////////////////////////////////////////////////////////////////
    // Hide menu and backdrop on backdrop click

    $('.main-backdrop').on('click', function(){
        $('.left-menu-toggle').removeClass('active');
        $('nav.left-menu').removeClass('left-menu-showed');
        $('nav.top-menu').toggleClass('ob-left-nav-adjust');
        $('.main-backdrop').removeClass('main-backdrop-showed')
    });
    
    $('nav.left-menu a.left-menu-link').on('click', function(){
        if (!$(this).parent().hasClass('left-menu-list-submenu')) {
            $('.left-menu-toggle').removeClass('active');
            $('nav.left-menu').removeClass('left-menu-showed');
            $('.main-backdrop').removeClass('main-backdrop-showed')
        }
    });

    //////////////////////////////////////////////////////////////////////////////
    // Material Effects

    if ($('body').hasClass('mode-material')) {
        (function($) {
            $("body").on('click', '.btn, .left-menu-link', function(e){

                var rippler = $(this)

                // Create .ink element if it doesn't exist
                if(rippler.find("> .ink").length == 0) {
                    $('.ink').remove();
                    rippler.append("<span class='ink'></span>");
                }

                var ink = rippler.find("> .ink");

                // Prevent quick double clicks
                ink.removeClass("animate");

                // Set .ink diameter
                if(!ink.height() && !ink.width())
                {
                    var d = Math.max(rippler.outerWidth(), rippler.outerHeight());
                    ink.css({height: d, width: d});
                }

                // Get click coordinates
                var x = e.pageX - rippler.offset().left - ink.width()/2;
                var y = e.pageY - rippler.offset().top - ink.height()/2;

                // Set .ink position and add class .animate
                ink.css({
                    top: y+'px',
                    left:x+'px'
                }).addClass("animate");

            })
        })(jQuery);
    }

});
